import { FleekError } from './FleekError';

type Template = {
  id?: string;
  name?: string;
};

type TemplateAlreadyExistsErrorOptions = {
  template: Template;
};

export class TemplateAlreadyExistsError extends FleekError<TemplateAlreadyExistsErrorOptions> {
  public name = 'TemplateAlreadyExistsError';

  toString = () => `Template already exists.`;
}
